import axios from 'axios'
import { errorHandler } from "../exports/error_management"
import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-interaction-type-key'
const api = async (method, path, params) => axios[method](path, params)

const state = {
    interaction_type: null,
    interaction_types: [],
}

const mutations = {
    set_interaction_type(state, payload) {
        state.interaction_type = payload
    },
    set_interaction_types(state, payload) {
        state.interaction_types = payload
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            const results = await api('post', `interaction-type`, payload)
            context.commit('set_interaction_type', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `interaction-type/${id}`)
            context.commit('set_interaction_type', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `interaction-type`)
                console.log("results.data", results.data)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_interaction_types', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateInteractionTypeItemOrder(context, payload) {
        new StorageCache(storageKey).reset()

        try {
            await api(
                'post',
                `interaction-type/update/display/order/`,
                payload
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async update(context, payload) {
        console.log('update', payload)
        new StorageCache(storageKey).reset()
        try {
            const results = await api(
                'put',
                `interaction-type/${payload.id}`,
                payload
            )
            context.commit('set_interaction_type', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        new StorageCache(storageKey).reset()
        try {
            await api('delete', `interaction-type/${id}`)
            context.commit('set_interaction_types', null)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}